<template>
  <div class="page page-about">

    <!-- Hero -->
    <div class="hero about-hero">

      <div class="hero-img">
        <parallax
          direction="down"
          breakpoint="(min-width: 50px)"
        >
          <picture>
            <source srcset="../assets/img/hero/about-hero.jpg" media="(min-width: 576px)">
            <img srcset="../assets/img/hero/about-hero-m.jpg" alt="">
          </picture>
        </parallax>
      </div>

      <div class="hero-content middle">
          <h1 class="page-title">About Me</h1>
      </div>

    </div>

    <!-- Content -->
    <div class="about-content">

      <div class="container">
        <p>After my daughter was born, I struggled with the challenge of losing the extra weight. Like so many of us, I tried every fad diet out there only to gain the weight back leaving myself feeling worse.</p>
        <p>I decided to sign up for my first Triathlon, started eating better foods and followed a training program. I was scared to death come race day, but I did it and nothing can compare to the incredible satisfaction of crossing that finish line!</p>
        <p>I felt empowered to do more. I loved the feeling of challenging myself physically & mentally and quickly became addicted to the rewards of hard work.</p>
        <p class="mb-5">I’ve channeled that passion into helping others discover their own power to become the best version possible.</p>
      </div>

      <!-- Certifications -->
      <Certifications />

      <!-- Services -->
      <Services />

    </div>

  </div>
</template>

<script>
import Parallax from '@/components/Parallax'
import Services from '@/components/Services'
import Certifications from '@/components/Certifications'

export default {
  components: {
    Parallax,
    Services,
    Certifications
  },

  created () {
    this.$emit('ready')
  }
}
</script>

<style lang="scss">
@import '../assets/scss/beach-built/imports';

.about-hero {
  margin-bottom: 20px;
  @include media-breakpoint-up(md) {
    margin-bottom: 40px;
  }
}
</style>
